"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const CommentSquareOutlineIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M1.75 3A.25.25 0 012 2.75h12a.25.25 0 01.25.25v7a.25.25 0 01-.25.25H6a1.79 1.79 0 00-.593.117c-.177.063-.36.148-.54.243-.36.188-.763.441-1.162.708-.402.27-.818.563-1.205.84l-.162.114c-.208.149-.405.29-.588.418V3zm.005 10.05l-.002-.005a.02.02 0 01.002.006z"
  })))
});
CommentSquareOutlineIcon.displayName = 'CommentSquareOutlineIcon';
var _default = exports.default = CommentSquareOutlineIcon;